import { useState } from 'react';
import type { FormEvent } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function LoginView() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center justify-center h-screen bg-obsidian-bg">
      <form
        onSubmit={handleSubmit}
        className="w-80 p-6 bg-obsidian-bg-secondary border border-obsidian-border rounded-lg"
      >
        <h1 className="text-lg font-semibold text-obsidian-text mb-1">
          Claude Code Insights
        </h1>
        <p className="text-sm text-obsidian-text-muted mb-6">
          Enter password to continue
        </p>

        {error && (
          <p className="text-sm text-red-400 mb-4">{error}</p>
        )}

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus
          className="w-full px-3 py-2 mb-4 text-sm text-obsidian-text bg-obsidian-bg border border-obsidian-border rounded-lg focus:outline-none focus:border-obsidian-accent placeholder:text-obsidian-text-faint"
        />

        <button
          type="submit"
          disabled={loading || !password}
          className="w-full px-3 py-2 text-sm font-medium text-obsidian-text bg-obsidian-accent rounded-lg hover:opacity-90 disabled:opacity-50 transition-opacity"
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
